import React from 'react'
import { createPortal } from 'react-dom'
import useStyles from './styles'

/**
 * Centered dialog on a dimmed backdrop. Without `onClose` a backdrop click
 * does nothing (the one-time API key dialog must be closed with Done).
 */
const Dialog = ({ onClose, className, children }) => {
  const classes = useStyles()
  return createPortal(
    <div className={classes.backdrop} onClick={onClose}>
      <div
        className={`${classes.dialog} ${className || ''}`}
        role="dialog"
        aria-modal="true"
        onClick={event => event.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body,
  )
}

export default Dialog
